import { CalendarOff, ShieldAlert } from "lucide-react";
import { useAuthStore } from "@/store/auth";
import { ContractorLeavesSection } from "../components/ContractorLeavesSection";
import { ORDER_CONFIRMATION_WINDOW_DAYS } from "../api/leaves";

/**
 * Portal podwykonawcy — „Moje urlopy": dni, w których cała firma nie pracuje.
 * Dostępne wyłącznie dla KONTA FIRMY, czyli konta z „Widocznością stawek" (ta sama flaga,
 * która daje kwoty, maile o zamówieniach i faktury); konta pracowników podwykonawcy dostają
 * wyjaśnienie zamiast listy. Backend bramkuje to samo (is_company_account).
 */
export function ContractorLeavesPage() {
  const user = useAuthStore((s) => s.user);
  const contractorId = user?.contractor_company ?? null;
  const isCompanyAccount = !!user?.can_see_rates;

  return (
    <div className="max-w-4xl">
      <div className="flex items-center gap-3 mb-6">
        <CalendarOff size={22} className="text-[var(--color-primary)]" />
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Moje urlopy</h1>
          <div className="w-8 h-0.5 bg-[var(--color-primary)] mt-1 mb-1" />
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Terminy, w których {user?.contractor_company_name ?? "firma"} nie pracuje. Zamawiający
            zobaczą je przy Waszej nazwie na liście podwykonawców.
          </p>
        </div>
      </div>

      {!contractorId || !isCompanyAccount ? (
        <div
          data-testid="contractor-leaves-no-access"
          className="bg-white dark:bg-gray-800 p-6 flex items-start gap-3"
        >
          <ShieldAlert size={20} className="text-amber-500 shrink-0 mt-0.5" />
          <div className="text-sm text-gray-700 dark:text-gray-300">
            <p className="font-medium">Urlopy firmy zgłasza tylko konto firmy.</p>
            <p className="mt-1 text-gray-500 dark:text-gray-400">
              Urlop podwykonawcy oznacza urlop całej firmy, nie pojedynczego konta — dlatego zgłasza
              go konto firmy, czyli konto z widocznością stawek i kwot na zamówieniach. Jeśli to Ty
              powinieneś je mieć, poproś opiekuna w GK ELEKTIM o włączenie widoczności stawek dla
              Twojego konta.
            </p>
          </div>
        </div>
      ) : (
        <>
          <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-700/50 px-4 py-3 mb-6 text-sm text-amber-800 dark:text-amber-200">
            Zamówienie trzeba potwierdzić w ciągu {ORDER_CONFIRMATION_WINDOW_DAYS} dni od wysłania.
            Jeśli w tym czasie macie urlop, Wasza firma trafia na koniec listy podwykonawców z dopiskiem
            „(urlop od–do)” — zamawiający wie, że może nie doczekać się potwierdzenia. Urlop możecie
            wycofać przed jego rozpoczęciem albo skrócić o przyszłe dni.
          </div>
          <ContractorLeavesSection contractorId={contractorId} canManage variant="portal" />
        </>
      )}
    </div>
  );
}
